<template>
  <section v-if="isLoading" />
  <MusicDetail v-else-if="currentProduct !== null && this.globalResources.portalType === this.portalType.Music" :product="currentProduct" />
  <GameDetail v-else-if="currentProduct !== null && this.globalResources.portalType === this.portalType.Game" :product="currentProduct" />
</template>

<script>
import Vue from 'vue'
import enums from '@/utilities/enums.js'
import GameDetail from '@/components/GameDetail.vue'
import MusicDetail from '@/components/MusicDetail.vue'
import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({
  name: 'ProductDetails',
  components: {
    GameDetail,
    MusicDetail
  },
  mixins: [enums],
  data () {
    return {
      isLoading: true,
      productId: 0
    }
  },
  computed: {
    ...mapGetters({
      cdnAddress: "tenantDesign/cdnAddress",
      product: 'productCatalog/product'
    }),
    currentProduct () {
      return this.product(this.productId)
    }
  },
  watch: {
    '$route.params.id': function () {
      this.loadProductInfo()
    }
  },
  created () {
    this.loadProductInfo()
  },
  methods: {
    ...mapActions({
      setMetas: "meta/update",  
      loadProduct: 'productCatalog/loadProduct'
    }),
    loadProductInfo () {
      this.isLoading = true
      window.scrollTo(0, 0)
      this.productId = Number(this.$route.params.id)
      if (this.currentProduct === null) {
        this.loadProduct(this.productId)
          .then(response => {
            if (this.currentProduct === null) {
              this.$router.push({ name: '404' })
            } else {
              this.isLoading = false
            }
            let result = response.body.result
            this.setMetas({
              title: result.name,
              description: result.description,
              logo: this.cdnAddress + result.icon,
              image: this.cdnAddress + result.banner
            })
          })
          .catch(error => {
            if (error) {
              this.$router.push({ name: '404' })
            }
          })
      } else {
        this.isLoading = false
      }
    }
  }
})
</script>
